<template>
  <div class="microphoneSelect flexcenter">
    <transition>
      <div class="microphoneSelectDialog flexcenter">
        <!-- 閉じる -->
        <div class="modal-close" @click="close"></div>
        <div class="microphoneSelectInner">
        <!-- タイトル -->
        <h3>マイク設定</h3>
        <div class="modal-inner">
          <div class="select1">
            <input type="radio" id="sreUseYes" value="true" v-model="sreUse"><label for="sreUseYes">音声機能を使用する</label>
            <div class="flexstart-align content" :class="sreUse">
              <div class="item"><h4>マイクの選択</h4></div>
              <div class="item">
                <div class="devices">
                  <div class="device" v-for="(microphone, index) in microphones">
                    <div class="font12" :class="{active:microphone.selected && sreUse == 'true'}" @click="selectMicrophone(index)">{{ microphone.name }}</div>
                  </div>
                </div>
                <div class="buttons  buttons-setting flexbetween">
                  <button class="reload flexcenter" type=button :disabled="sreUse === 'false'" @click="updateList"><span>一覧を更新</span></button>
                  <button class="help flexcenter" type=button :disabled="sreUse === 'false'" @click="$emit('showMicrophoneHelp')"><span>マイク設定について</span></button>
                </div>
                <p class="font12">※お使いのマイクがこの一覧に表示されないときは、マイクが接続されていることを確認してから、[一覧を更新]をクリックしてください。</p>
                <p class="font12">※マイク設定について詳しくは、[マイク設定について]をクリックしてください。</p>
              </div>
            </div>
          </div>
          <div class="select2">
            <input type="radio" id="sreUseNo" value="false" v-model="sreUse"><label for="sreUseNo">音声機能を使用しない</label>
          </div>
        </div>
        <!-- ボタン -->
        <div class="buttons buttons-footer flexcenter">
          <button class="cancel" type=button @click="close">キャンセル</button>
          <button class="continue" type=button @click="doContinue" :disabled="(sreUse == 'true' && selectedMicrophone == null)">続行</button>
        </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import common from '@/mixin/common'
import http from '@/mixin/http'
import * as constants from '@/mixin/constants'

export default {
  name: 'microphoneSelect',
  mixins: [
    common,
    http,
  ],
  props: {
    isSettingApply: Boolean,
  },
  data: function() {
    return {
      sreUse: 'true',
      microphones: [],
      selectedMicrophone: null,
    }
  },
  methods: {
    /**
     * マイク一覧更新
     */
    updateList: async function () {
      this.setList(await this.getMicrophones(), this.selectedMicrophone)
    },
    /**
     * マイク一覧に設定
     *
     * @param {Array} microphones マイクオブジェクト一覧
     * @param {Object} current マイクオブジェクト
     */
    setList: function (microphones, current) {
      this.microphones = []
      this.selectedMicrophone = null
      for (var microphone of microphones) {
        var selected = current && microphone.id == current.id
        this.microphones.push({
          name: microphone.name,
          id: microphone.id,
          selected: selected,
        })
        if (selected) {
          this.selectedMicrophone = { name: microphone.name, id: microphone.id }
        }
      }
    },
    /**
     * マイクを選択
     *
     * @param {Number} selectedIndex 選択したマイクのインデックス
     */
    selectMicrophone: function(selectedIndex) {
      if(this.sreUse == 'false') {
        return
      }
      for(var i = 0; i < this.microphones.length; i++) {
        var microphone = this.microphones[i]
        microphone.selected = i == selectedIndex
        if (microphone.selected) {
          this.selectedMicrophone = { name: microphone.name, id: microphone.id }
        }
      }
    },
    /**
     * 続行処理
     */
    doContinue: async function() {
      this.log("MicrophoneSelect start doContinue")
      var self = this

      if(self.sreUse == "true") {
        // マイク設定要否判定
        if (await self.needsMicrophoneSetting(self.selectedMicrophone)) {
          // マイク一覧更新
          self.setList(await self.getMicrophones(), self.selectedMicrophone)
        } else {
          // マイク設定画面を表示
          self.$emit('showMicrophoneSetting', self.selectedMicrophone)
        }
      } else {
        // 音声機能使用有無状態を設定画面と共有
        var setting = self.$parent.$children.find(function(child){ return child.$options.name == "setting" })
        if (setting) {
          setting.sreUse = self.sreUse
        }

        // 設定を「音声機能使用しない」に更新して画面を閉じる
        self.$store.dispatch('setSreUse', self.sreUse)

        // 設定画面の適用ボタンクリックで起動時
        if (self.isSettingApply) {
          // key-value設定API実行
          self.setKeyValue(self.$parent.productInfo.code, self.getApiParam())
            .then(function(response) {
              switch (response.result_code) {
                case 'OK':
                  self.close()
                  break
                case 'INFO_INVALID_ACCESSKEY':
                  var message = response.result_code;
                  self.$emit('showError', message, constants.ERROR_BUTTON_KIND_LOGIN)
                  break
                default:
                  self.close()
                  break
              }
            })
            .catch(function(err) {
              self.close()
            })
        } else {
          self.close()
        }
      }
    },
    /**
     * key-value設定APIパラメータ取得
     *
     * @return {String} key-value設定APIパラメータ：datajson文字列
     */
    getApiParam: function() {
      var result = { data: [] }
      result.data.push(this.getApiParamKeyValue(constants.DATA_SETTING_SRE_USE, this.sreUse))

      return JSON.stringify(result)
    },
    /**
     * key-value設定APIパラメータ取得
     *
     * @param {String} key キー名
     * @param {String} value 設定値
     * @return {Object} key-valueオブジェクト
     */
    getApiParamKeyValue: function(key, value) {
      var result = {}
      result[key] = value
      return result
    },
    /**
     * 本画面を閉じる
     */
    close: function () {
      // 設定画面の適用ボタンクリックで起動時
      if (this.isSettingApply) {
        var setting = this.$parent.$children.find(function(child){ return child.$options.name == "setting" })
        if (setting) {
          setting.$emit('close')
        }
      }
      this.$emit('close')
    },
  },
  created: async function() {
    this.log("MicrophoneSelect start created")
    this.setList(await this.getMicrophones(), sonic_wrapper.getMicrophone())
  },
  mounted: function() {
    this.log("MicrophoneSelect start mounted")
    this.setBodyStylePosition(true)
  },
  beforeDestroy: function() {
    this.setBodyStylePosition(false)
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// MicrophoneSelect.vue?9b85265a